export default {
  notFoundComponent: {
    pageNotFound: 'Página não encontrada :-(',
    tryToSearch: 'Tente realizar uma busca'
  }
}
